<ng-container *ngIf="design == 'OLD'">
	<div [ngClass]="{'error': error === true, 'mx-auto' : centerBox}" class="pin-container" id="pin-container-box">
		<div (click)="callFocus(index)" *ngFor="let pin of pinArray;let index = index"
			 class="password-box flex flex-row items-center relative">
			<input (focus)="onPaste($event)" (keyup)="allowOnlyNumbers($event, index)" (paste)="onPaste($event)"
				   [ngClass]="{ 'text-state-error caret-state-error bg-state-error/10': error , 'ml-[12px]':index > 0}"
				   id="{{ id }}-{{ index }}" inputmode="numeric" maxlength="1" nz-input pattern="[0 - 9]*"
				   type="{{ type }}"/>
			<div (click)="callFocus(index)" [ngClass]="{'left-[13.5px]':index === 0, 'left-[25.5px]':index > 0}"
				 class="svgs-div absolute">
				<ng-container *ngIf="!savedPin[index]; else activeTemplate">
					<svg fill="none" height="10" viewBox="0 0 10 10" width="10" xmlns="http://www.w3.org/2000/svg">
						<circle cx="5" cy="5" fill="#9DA1AB" opacity="0.4" r="5"/>
					</svg>
				</ng-container>
				<ng-template #activeTemplate>
					<svg fill="none" height="10" viewBox="0 0 10 10" width="10" xmlns="http://www.w3.org/2000/svg">
						<circle [ngClass]="{ 'fill-state-error': error}" cx="5" cy="5" fill="#0361F0" r="5"/>
					</svg>
				</ng-template>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="design == 'NEW'">
	<div [ngClass]="{'error': error === true, 'mx-auto' : centerBox}" class="pin-container border-0 h-40" id="pin-container-box">
		<div (click)="callFocus(index)" *ngFor="let pin of pinArray;let index = index"
			 class="password-box flex flex-row items-center relative">
			<input (focus)="onPaste($event)" (keyup)="allowOnlyNumbers($event, index)" (paste)="onPaste($event)"
				   [ngClass]="{'text-state-error caret-state-error bg-state-error/10': error , 'ml-[12px]':index > 0}"
				   id="{{ id }}-{{ index }}" inputmode="numeric" maxlength="1" nz-input pattern="[0 - 9]*"
				   type="{{ type }}"/>
			<div (click)="callFocus(index)" [ngClass]="{'left-[13.5px]':index === 0, 'left-[25.5px]':index > 0}"
				 class="svgs-div absolute">
				<ng-container *ngIf="!savedPin[index]; else activeTemplate">
					<svg fill="none" height="10" viewBox="0 0 10 10" width="10" xmlns="http://www.w3.org/2000/svg">
						<circle cx="5" cy="5" fill="#9DA1AB" opacity="0.4" r="5"/>
					</svg>
				</ng-container>
				<ng-template #activeTemplate>
					<svg fill="none" height="10" viewBox="0 0 10 10" width="10" xmlns="http://www.w3.org/2000/svg">
						<circle [ngClass]="{ 'fill-state-error': error}" cx="5" cy="5" fill="#0361F0" r="5"/>
					</svg>
				</ng-template>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="design == 'VERSION_ONBOARDING'">
	<div
	[ngClass]="{'error':error === true, 'onboarding-version-border':hasBorder, 'mx-auto' : centerBox}"
	  class="pin-container border-0 pin-container-onboarding-version-design"
	  id="pin-container-box"
	>
	  <div
		(click)="callFocus(index)"
		*ngFor="let pin of pinArray;let index = index"
		class="password-box onboarding-version-design flex items-center relative"
		[ngClass]="{'left-spacing':index > 0}"

	  >
		<input
		  (focus)="onPaste($event)"
		  (keyup)="allowOnlyNumbers($event, index)"
		  (paste)="onPaste($event, index)"
		  [ngClass]="{'input-state-error caret-state-error': error }"
		  id="{{ id }}-{{ index }}"
		  [class]="inputClass"
		  inputmode="numeric"
		  maxlength="1"
		  nz-input
		  pattern="[0 - 9]*"
		  type="{{ showPassword ? type : 'text' }}"
		/>
		<div *ngIf="showPassword"
		  (click)="callFocus(index)"
		  [ngClass]="{'left-[13.5px]':index === 0, 'left-[25.5px]':index > 0}"
		  class="svgs-div absolute"
		>
			<ng-container *ngIf="usePasswordCoverIcon">

				<ng-container
					*ngIf="passwordCoverIconTemplateRef"
					[ngTemplateOutlet]="passwordCoverIconTemplateRef"
					[ngTemplateOutletContext]="{$implicit:{active: !!savedPin[index]}}"
				>
				</ng-container>
			</ng-container>
			<ng-container *ngIf="!usePasswordCoverIcon">
			<ng-container *ngIf="!savedPin[index]; else activeTemplate">
				<svg
				fill="none"
				height="10"
				viewBox="0 0 10 10"
				width="10"
				xmlns="http://www.w3.org/2000/svg"
				>
				<circle cx="5" cy="5" fill="#9DA1AB" opacity="0.4" r="5" />
				</svg>
			</ng-container>
			<ng-template #activeTemplate>
				<svg
				fill="none"
				height="10"
				viewBox="0 0 10 10"
				width="10"
				xmlns="http://www.w3.org/2000/svg"
				>
				<circle
					[ngClass]="{ 'fill-state-error': error}"
					cx="5"
					cy="5"
					fill="#0361F0"
					r="5"
				/>
				</svg>
			</ng-template>
			</ng-container>
		</div>
	  </div>
	</div>
  </ng-container>
